"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var VolumeOff = function VolumeOff(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/av/volume_off-volume-off" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-volume-off" + unique,
    xlinkHref: "#path-1-volume-off" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-volume-off" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.1089,8.0464 C5.1659,7.9344 5.2449,7.8324 5.3409,7.7474 L11.3409,2.4974 C11.7569,2.1334 12.3889,2.1754 12.7529,2.5914 C12.9119,2.7744 12.9999,3.0074 12.9999,3.2504 L12.9999,20.8424 C12.9999,21.3944 12.5519,21.8424 11.9999,21.8424 C11.7579,21.8424 11.5239,21.7544 11.3409,21.5944 L5.3409,16.3444 C5.2449,16.2594 5.1659,16.1584 5.1089,16.0464 L3.9999,16.0464 C2.8959,16.0464 1.9999,15.1504 1.9999,14.0464 L1.9999,10.0464 C1.9999,8.9424 2.8959,8.0464 3.9999,8.0464 L5.1089,8.0464 Z",
    fill: "inherit",
    id: "path-1-volume-off" + unique
  }))));
};

VolumeOff.propTypes = propTypes;
var _default = VolumeOff;
exports["default"] = _default;